module.exports = __webpack_public_path__ + "img/eltine.9ec6eb43.jpg";